import { env } from './env';

/**
 * Whether the STRESS debug globals (`__SIRONA_REPORTER__`, `__SIRONA_APOLLO_CACHE__`) may mount.
 *
 * Requires a non-production build AND a runtime opt-in that the STRESS harness sets on the page
 * before app code runs (Playwright `addInitScript`). Ordinary dev, staging and preview sessions
 * never set it, so they get neither global nor the instrumented Apollo cache. Those environments
 * can hold real patient data, and `__SIRONA_REPORTER__` exposes report text.
 *
 * Read at call time: the opt-in is a per-page runtime signal, so no rebuild is needed.
 */
export const isStressDebugHooksEnabled = (): boolean =>
  env.DEPLOY_ENV !== 'production' &&
  typeof window !== 'undefined' &&
  window.__SIRONA_STRESS_OPT_IN__ === true;
